import axios from 'axios';
import config from '../config';

// Define a URL base para todas as chamadas do Axios.
// O Create React App selecionará o arquivo .env apropriado (development ou production)
// durante o processo de build, e injetará a variável de ambiente correta.
axios.defaults.baseURL = config.apiBaseURL;

// O token de autenticação já é tratado pelo seu AuthContext, então não precisamos
// de um interceptor para isso aqui, a menos que haja outras configurações globais.

// Interceptor de resposta — trata erros globais
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      // Token expirado ou inválido — força logout
      delete axios.defaults.headers.common['Authorization'];
      window.location.href = '/login';
    }

    if (status === 403) {
      console.warn('Acesso negado.');
    }

    if (status === 500) {
      console.error('Erro interno do servidor.');
    }

    return Promise.reject(error);
  }
);

export default axios;
